import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { stylesPdf } from '../../../pdfs';

const FooterBoletinesPdf = () => {
  return (
    <View>
      <View
        style={[
          stylesPdf.cell,
          {
            borderTopWidth: 0,
          },
        ]}
      >
        <Text
          style={[
            stylesPdf.title,
            {
              textAlign: 'center',
            },
          ]}
        >
          ORIENTACION Y CONVIVENCIA
        </Text>
      </View>
      <View
        style={[
          stylesPdf.cell,
          {
            borderTopWidth: 0,
            height: '50%',
          },
        ]}
      ></View>
    </View>
  );
};

export default FooterBoletinesPdf;
